/**
 * Copyright (C), 2012-2021, Sichuan Xiaoka Technology Co., Ltd.
 * 导航守卫
 * */
import router from "../router";
import store from '../store'

// 新增模块的权限ID（后端未配置时临时放行）
const newModuleIds = [
    // 数据分析模块
    129, 133, 134,
    // 渠道管理模块
    200, 201, 202, 203, 204, 205, 206,
    // 菜单管理模块
    207,
    // 文旅专线新增子菜单（酒店管理/景区管理/行程模板）
    208, 209, 210,
    // 旅游包车独立一级菜单
    211,
    // 统计分析-增强统计
    212,
    // 协议中心
    213, 214, 215
];

// 全局前置守卫
router.beforeEach((to, from, next) => {
    // 无需认证的页面直接放行
    if (to.meta && to.meta.noAuth) {
        next();
        return;
    }
    
    let str = store.getters.permissionsGetter;
    if (str) {
        let permissions = str ? str.split(',').map(value => Number(value)) : []; // 获取权限序列
        let id = to.matched.length > 0 ? to.matched[to.matched.length - 1].meta.id : '';
        
        if (to.matched.length === 0) { // 路由不存在，跳转至404页面
            next('/404');
        } else if (id && !permissions.includes(id)) {
            // 新增模块临时放行（后端配置权限后可移除此判断）
            if (newModuleIds.includes(id)) {
                next();
            } else {
                next('/404');
            }
        } else {
            next();
        }
    } else {
        next();
    }
});